var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "完成时间", prop: "searchDates" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  size: "small",
                  align: "right",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  "unlink-panels": "",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "picker-options": _vm.pickerOptions,
                },
                model: {
                  value: _vm.searchDates,
                  callback: function ($$v) {
                    _vm.searchDates = $$v
                  },
                  expression: "searchDates",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "top bg-white" },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              export: "",
              print: "",
              custom: "",
            },
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 80px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "todoTable",
                  attrs: {
                    border: "inner",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {},
                    "export-config": {},
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "任务", field: "name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.name) + " "),
                            scope.row.back
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "warning", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.callback(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("撤销")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { title: "实例标题", field: "vars.title" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "流程名称",
                      field: "processDefinitionName",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "办理状态", field: "status" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: scope.row.level,
                                  effect: "dark",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.status) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { title: "流程发起人", field: "vars.userName" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "endTime", title: "完成时间" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "100px",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.detail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("历史")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  background: "",
                  size: "small",
                  "current-page": _vm.tablePage.currentPage,
                  "page-size": _vm.tablePage.pageSize,
                  total: _vm.tablePage.total,
                  "page-sizes": [
                    10,
                    20,
                    100,
                    1000,
                    { label: "全量数据", value: 1000000 },
                  ],
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.currentChangeHandle },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }